import gql from 'graphql-tag';

const GET_LEAD_ON_EDIT = gql`
query getLeadsByFilter($filter: LeadFilter){
    getLeads(filter:$filter) {
    Leads {
      id
      red_flag {
        description
        createdAt
        updatedAt
      }
      first_name_1
      last_name_1
      primary_email_1
      secondary_emails_1
      cell_phone_1
      first_name_2
      last_name_2
      primary_email_2
      secondary_emails_2
      primary_email_1_status
      primary_email_2_status
      cell_phone_2
      street_address
      city
      osc_notes
      realtor {
        id
        first_name
        last_name
        primary_email
        cell_phone
      }
      customer_origination_area {
        id
        name
      }
      state {
        id
        name
      }
      next_steps {
        id
        note
        created_at
        creator {
          id
          first_name
          last_name
        }
      }
      motivation_what_changed
      motivation_what_changed_score
      cost_feat_objections
      cost_feat_objections_score
      future_promise
      future_promise_score
      current_dissatisfaction
      current_dissatisfaction_score
      motivation_uncovered
      lead_classification_filters {
        id
        name
      }
      zip
      other_notes
      quality_score
      engagement_score
      communities {
        id
        name
        is_active
        division_id
      }
      divisions {
        id
      }
    }
    total_count
  }
 }
 `;

export default GET_LEAD_ON_EDIT;